/**
 * App-wide state (theme, user). Per memory `feedback_svelte5_state_object_pattern`:
 * cross-module $state has gotchas — we stash theme in localStorage and apply
 * it via [data-theme] on <html>. No reactive cross-module proxy needed.
 */
import { tgUser } from "./tg";

const THEME_KEY = "kvin:theme";

export type Theme = "dark" | "light";

export function getTheme(): Theme {
  const fromStorage = localStorage.getItem(THEME_KEY) as Theme | null;
  if (fromStorage === "dark" || fromStorage === "light") return fromStorage;
  // default to dark (brand canon)
  return "dark";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem(THEME_KEY, theme);
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
}

export interface CurrentUser {
  tgId: number;
  firstName: string;
  lastName?: string;
  username?: string;
  photoUrl?: string;
  role: "director" | "manager" | "installer" | "integration" | "unknown";
  amoUserAmoId?: number;
}

export function bootstrapUser(): CurrentUser {
  const u = tgUser();
  if (!u) {
    // Browser preview mode — explicit «Гость» / unknown, no role assumed.
    // App.svelte gates role-dependent UI (mic, ping buttons, etc) on actual role.
    return {
      tgId: 0,
      firstName: "Гость",
      role: "unknown",
    };
  }
  return {
    tgId: u.id,
    firstName: u.first_name ?? "Гость",
    lastName: u.last_name,
    username: u.username,
    photoUrl: u.photo_url,
    role: "unknown",
  };
}
